import resources from "../../core/Localization/Localization";
import { getDateString } from "../../utils/getDateString";

export const carColumns = () => [
    {
        field: "id",
        headerName: resources.userVehicles.datagrid.id,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "make",
        headerName: resources.userVehicles.datagrid.make,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "model",
        headerName: resources.userVehicles.datagrid.model,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "generation",
        headerName: resources.userVehicles.datagrid.generation,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "motor",
        headerName: resources.userVehicles.datagrid.motor,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "title",
        headerName: resources.userVehicles.datagrid.title,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "vin",
        headerName: resources.userVehicles.datagrid.vin,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "owner",
        headerName: resources.userVehicles.datagrid.owner,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }
];
